import { jsx as _jsx } from "react/jsx-runtime";
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { SuiteTile } from './SuiteTile';
import { borderStyle, StyledCardGrid } from './MerchCardSharedComponents';
import { FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import SuiteFreeTile from './SuiteFreeTile';
import { ConditionalWrapper, SuiteTileWrapper } from '../ebx633/ConditionalWrapper';
import { useSelector } from 'react-redux';
import { isStarterGWPSelector } from '../../selectors/GatingSelectors';
import { isProGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
export const SuiteTiles = ({
  selectedTab,
  isEbx633
}) => {
  let productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab
  });

  if (isEbx633) {
    productLevelsToShow = [FREE, STARTER];
  }

  const isStarterGWP = useSelector(isStarterGWPSelector);
  const isProGWP = useSelector(isProGWP2023EligibleSelector);
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 28,
      paddingRight: 28,
      borderRight: borderStyle,
      borderLeft: borderStyle
    };
    const disclaimer = productLevel === STARTER && isStarterGWP ? `pricingPage.promotions.starterGWPDisclaimer` : productLevel === PROFESSIONAL && isProGWP ? 'pricingPage.promotions.proGWPDisclaimer' : undefined;

    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(ConditionalWrapper, {
        condition: isEbx633,
        wrapper: SuiteTileWrapper,
        children: /*#__PURE__*/_jsx(SuiteFreeTile, {
          commonStyles: commonStyles,
          isEbx633: isEbx633
        }, productLevel)
      }, productLevel);
    }

    return /*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: isEbx633,
      wrapper: SuiteTileWrapper,
      children: /*#__PURE__*/_jsx(SuiteTile, {
        productLevel: productLevel,
        commonStyles: commonStyles,
        disclaimer: disclaimer,
        isEbx633: isEbx633
      }, productLevel)
    }, productLevel);
  });
  return /*#__PURE__*/_jsx("div", {
    className: "flex-column align-center justify-center",
    style: {
      width: `${isEbx633 && '100%'}`
    },
    children: /*#__PURE__*/_jsx(StyledCardGrid, {
      columns: productLevelsToShow.length,
      columnGap: isEbx633 ? 64 : undefined,
      isEbx633: isEbx633,
      children: suiteCardComponents
    })
  });
};